import { SectionHeader } from "@/components/common/section-header";
import { RelatedCard } from "@/components/destinations-page/related-cards-row";
// eslint-disable-next-line import/no-cycle
import { InterlinkingDestinationsMenu } from "@/types/dto/landing-page/landing-page";
import { Box } from "@mui/material";
import Grid from "@mui/material/Grid";
import React from "react";

export interface InterlinkingMenuProps {
  destinations: InterlinkingDestinationsMenu;
  moduleRankingPosition?: string;
  arrowIconFlag?: boolean;
}

const InterlinkingMenu = ({ destinations, moduleRankingPosition = "2", arrowIconFlag = false }: InterlinkingMenuProps) => {
  const getCardStyles = () => ({
    height: {
      xs: 150,
      sm: 200,
      md: 150
    },
    borderRadius: "2rem",
    gradient: {
      xs: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.60) 100%)",
      sm: "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 50%, rgba(0, 0, 0, 0.60) 90.75%)"
    }
  });

  const cardCount = destinations?.destinations?.length || 0;
  let gridSize = 2.4;
  if (cardCount < 5) {
    gridSize = 12 / cardCount;
  }

  return (
    <Box
      component="section"
      sx={{ backgroundColor: "background.warm_strong" }}
      data-track="visibility"
      data-parent-container-type="carousel"
      data-module-name="Interlinking Destinations Menu"
      data-ranking-algorithm="manual"
      data-module-ranking-position={moduleRankingPosition}
      data-testid="interlinking-destinations-menu"
    >
      <Box
        className="destination-page-container"
        data-testid="interlinking-menu-container"
        sx={{
          padding: {
            xs: "4rem 2.4rem",
            sm: "4rem 3.2rem",
            lg: "6rem 10rem"
          },
          display: "flex",
          flexDirection: "column",
          gap: "2rem"
        }}
      >
        <SectionHeader
          headerText={destinations.basicInfo.headerText}
          headerTestId="interlinking-menu-header-text"
          headerSx={{
            textTransform: "none !important",
            color: "primary.main",
            fontSize: { xs: "2.4rem", sm: "2.6rem", md: "2.8rem" },
            textAlign: { xs: "left !important", md: "center !important" }
          }}
          copyText={destinations.basicInfo.copyText}
          copyTestId="interlinking-menu-copy-text"
          copySx={{
            textAlign: { xs: "left !important", md: "center !important" },
            "& p": { margin: "0 !important" }
          }}
          sx={{ gap: "2.4rem" }}
        />
        <Grid
          container
          spacing={2}
          data-testid="interlinking-menu-grid"
          sx={{justifyContent:{md:"center"}}}
        >
          {destinations.destinations &&
            destinations.destinations.slice(0, 5).map((destination, index) => (
              <Grid
                key={destination.id ?? `${index}-${destination.name}`}
                size={{ xs: 12, sm: 6, md: gridSize }}
                data-testid={`interlinking-menu-card-${index}`}
              >
                <RelatedCard
                  data-testid={`interlinking-menu-related-card-${index}`}
                  destination={{
                    id: destination.id ?? index,
                    name: destination.name,
                    altText: destination.altText,
                    imageUrl: destination.imageUrl,
                    url: destination.url
                  }}
                  getCardStyles={getCardStyles}
                  arrowIconFlag={arrowIconFlag}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Box>
  );
};

export default InterlinkingMenu;
